export default __webpack_public_path__ + "static/media/atr-logo.2ee428af.png";